"use strict";
// @ts-ignore
try {
    self['workbox:window:6.1.5'] && _();
}
catch (e) { }
